import React, { useContext } from 'react'
import { fade, makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import { NavLink } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import './dashboard.css'
import AuthContext from '../../../Product/context/auth/authContext'
import {
    Collapse,
    Divider,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    SwipeableDrawer,
    useMediaQuery,
} from '@material-ui/core'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { StarBorder } from '@material-ui/icons'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { ThemeConstant } from '../../../utils/ThemeConstants'
import SecondaryButton from '../../../Product/components/atoms/SecondaryButton'
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    dashboardheader: {
        background: '#f5f5f5',
        boxShadow: 'none',
        height: 64,
        marginTop: 30,
    },
    toolbar: {
        background: '#f5f5f5',
        maxWidth: '1280px',
        width: '100%',
        margin: '0 auto',
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing(7),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 7),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    sectionDesktop: {
        display: 'none',
        margin: 0,
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
}))

const DashboardHeader = ({ title, subtitle, savedcards, seller, invoices }) => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)
    const isMenuOpen = Boolean(anchorEl)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
    const authContext = useContext(AuthContext)
    const { isAuthenticated, logout, user } = authContext
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    // function handleProfileMenuOpen(event) {
    //   setAnchorEl(event.currentTarget);
    // }

    function handleMobileMenuClose() {
        setMobileMoreAnchorEl(null)
    }

    function handleMenuClose() {
        setAnchorEl(null)
        handleMobileMenuClose()
    }

    function handleMobileMenuOpen(event) {
        setMobileMoreAnchorEl(event.currentTarget)
    }

    const logoutUser = () => {
        logout()
        history.push('/login')
        window.location.reload()
    }

    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    const [openBids, setOpenBids] = React.useState(false)
    const [openPurchase, setOpenPurchase] = React.useState(false)
    const [openPickup, setOpenPickup] = React.useState(false)
    const [openMobileDrawer, setOpenMobileDrawer] = React.useState(false)
    const isSmallDesktop = useMediaQuery('(max-width:990px)')

    const toggleDrawer = (anchor, open) => (event) => {
        setOpenMobileDrawer({ ...openMobileDrawer, [anchor]: open })
    }

    return (
        <>
            {isVarifiedGfTheme ? (
                <>
                    {isSmallDesktop && (
                        <SecondaryButton
                            btnSize="dashboardDrawerBtn"
                            onClick={toggleDrawer('right', true)}
                        >
                            <span className="material-icons-outlined mr-2">sort</span>
                            Menu
                        </SecondaryButton>
                    )}
                    {!isSmallDesktop && (
                        <div className={`dashSideWrapper`}>
                            <List
                                component="nav"
                                aria-labelledby="nested-list-subheader"
                                subheader={
                                    <ListSubheader component="div" id="nested-list-subheader">
                                        Hello, {user?.first_name} {user?.last_name}
                                    </ListSubheader>
                                }
                                className={classes.root}
                            >
                                <ListItem button>
                                    <NavLink to="/dashboard/profile" activeClassName="active">
                                        My Information
                                    </NavLink>
                                    {/* {openPurchase ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} */}
                                </ListItem>
                                <ListItem button>
                                    <NavLink
                                        to="/dashboard/mybids?s=0"
                                        activeClassName={
                                            window.location.search == '?s=0' ||
                                            window.location.search == '?s=1' ||
                                            window.location.search == '?s=1&w=0' ||
                                            window.location.search == '?s=1&w=1' ||
                                            window.location.search == '?s=2' ||
                                            window.location.search == '?s=3'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        My Bids
                                    </NavLink>
                                    {/* {openBids ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} */}
                                </ListItem>
                                <ListItem button>
                                    <NavLink
                                        to="/dashboard/mycart"
                                        activeClassName="active"
                                        // activeClassName={
                                        //     window.location.search == '/dashboard/mycart'
                                        //         ? 'active'
                                        //         : null
                                        // }
                                    >
                                        My Cart
                                    </NavLink>
                                    {/* {openBids ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} */}
                                </ListItem>
                                <Collapse in={openPurchase} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <ListItem
                                            button
                                            className={` ${
                                                window.location.pathname == '/449/dashboard/profile'
                                                    ? 'active'
                                                    : null
                                            } ${classes.nested}`}
                                        >
                                            <NavLink
                                                to="/dashboard/profile"
                                                activeClassName="active"
                                            >
                                                Profile
                                            </NavLink>
                                        </ListItem>
                                        {/* <ListItem
                                        button
                                        className={` ${
                                            window.location.pathname == '/449/dashboard/cards'
                                                ? 'active'
                                                : null
                                        } ${classes.nested}`}
                                    >
                                        <NavLink to="/dashboard/cards" activeClassName="active">
                                            Saved Cards
                                        </NavLink>
                                    </ListItem> */}
                                    </List>
                                </Collapse>
                                {!isBargainsProject && (
                                    <ListItem
                                        button
                                        className={
                                            window.location.search == 'scheduledPickup'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink to="/dashboard/scheduledPickup">
                                            Ready for Pickup
                                        </NavLink>
                                    </ListItem>
                                )}
                                {!isBargainsProject && !ThemeConstant?.isBuyBestProject && (
                                    <ListItem
                                        button
                                        className={
                                            window.location.search == 'abandoned' ? 'active' : null
                                        }
                                    >
                                        <NavLink to="/dashboard/abandoned">Abandoned</NavLink>
                                    </ListItem>
                                )}
                                {global?.pluginConfiguration?.warranty_return_sku?.enable == 1 ? (
                                    <ListItem
                                        button
                                        className={
                                            window.location.search == 'warranty' ? 'active' : null
                                        }
                                    >
                                        <NavLink to="/dashboard/warranty">Extended Pickup</NavLink>
                                    </ListItem>
                                ) : (
                                    ''
                                )}
                                {global.pluginConfiguration?.extended_pickup?.enable == 1 ? (
                                    <ListItem
                                        button
                                        className={
                                            window.location.search == 'warranty' ? 'active' : null
                                        }
                                    >
                                        <NavLink to="/dashboard/extendedPickup">
                                            Extended Pickup History
                                        </NavLink>
                                    </ListItem>
                                ) : (
                                    ''
                                )}
                                {global.pluginConfiguration?.reward_points?.enable ? (
                                    <>
                                        <ListItem
                                            button
                                            className={
                                                window.location.search == 'rewards'
                                                    ? 'active'
                                                    : null
                                            }
                                        >
                                            <NavLink to="/dashboard/rewards">Rewards</NavLink>
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={
                                                window.location.search == 'Redeem' ? 'active' : null
                                            }
                                        >
                                            <NavLink to="/dashboard/redeem">Rush Perks</NavLink>
                                        </ListItem>
                                    </>
                                ) : (
                                    ''
                                )}
                                {/* <ListItem
                                    button
                                    className={window.location.search == 'Qrcode' ? 'active' : null}
                                >
                                    <NavLink to="/dashboard/qrcode">Kiosk</NavLink>
                                </ListItem> */}
                                {/* <ListItem button onClick={() => setOpenPickup(!openPickup)}>
                                <NavLink activeClassName="active" to="/dashboard/mybids?s=1&w=2">
                                    Item to Pickup
                                </NavLink>
                                {openPickup ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                            </ListItem>
                            <Collapse in={openPickup} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button className={classes.nested}>
                                        <NavLink
                                            to="/dashboard/mybids?s=1&w=2"
                                            activeClassName="active"
                                        >
                                            Scheduled Pickup
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse> */}
                                <Collapse in={openBids} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <ListItem
                                            button
                                            className={` ${
                                                window.location.search == '?s=0' ? 'active' : null
                                            } ${classes.nested}`}
                                        >
                                            <NavLink
                                                to="/dashboard/mybids?s=0"
                                                activeClassName={
                                                    window.location.search == '?s=0'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                Active
                                            </NavLink>
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={` ${
                                                window.location.search == '?s=1' ? 'active' : null
                                            } ${classes.nested}`}
                                        >
                                            <NavLink
                                                to="/dashboard/mybids?s=1"
                                                activeClassName={
                                                    window.location.search == '?s=1'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                Won
                                            </NavLink>
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={` ${
                                                window.location.search == '?s=2' ? 'active' : null
                                            } ${classes.nested}`}
                                        >
                                            <NavLink
                                                to="/dashboard/mybids?s=2"
                                                activeClassName={
                                                    window.location.search == '?s=2'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                Closed
                                            </NavLink>
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={` ${
                                                window.location.search == '?s=3' ? 'active' : null
                                            } ${classes.nested}`}
                                        >
                                            <NavLink
                                                to="/dashboard/mybids?s=3"
                                                activeClassName={
                                                    window.location.search == '?s=3'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                Buy Now
                                            </NavLink>
                                        </ListItem>
                                    </List>
                                </Collapse>
                                <ListItem
                                    button
                                    className={
                                        window.location.pathname == '/449/dashboard/cards'
                                            ? 'active'
                                            : null
                                    }
                                >
                                    <NavLink to="/dashboard/cards" activeClassName="active">
                                        Saved Cards
                                    </NavLink>
                                </ListItem>
                                <ListItem
                                    button
                                    className={
                                        window.location.pathname == '/449/dashboard/favorites'
                                            ? 'active'
                                            : null
                                    }
                                >
                                    <NavLink to="/dashboard/favorites" activeClassName="active">
                                        Watchlist
                                    </NavLink>
                                </ListItem>
                                <ListItem
                                    button
                                    className={
                                        window.location.pathname == '/449/dashboard/savedSearch'
                                            ? 'active'
                                            : null
                                    }
                                >
                                    <NavLink to="/dashboard/savedSearch" activeClassName="active">
                                        Saved Search
                                    </NavLink>
                                </ListItem>

                                <>
                                    <ListItem
                                        button
                                        className={
                                            window.location.pathname == '/dashboard/transactions'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink
                                            to="/dashboard/transactions"
                                            activeClassName="active"
                                        >
                                            {ThemeConstant?.isBuyBestProject
                                                ? 'Book Your Appointment'
                                                : 'Purchase History'}
                                        </NavLink>
                                    </ListItem>
                                    <ListItem
                                        button
                                        className={
                                            window.location.pathname == '/dashboard/preference'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink
                                            to="/dashboard/preference"
                                            activeClassName="active"
                                        >
                                            Preferences
                                        </NavLink>
                                    </ListItem>
                                </>

                                <ListItem button onClick={logoutUser}>
                                    Log Out
                                </ListItem>
                            </List>
                        </div>
                    )}
                    <React.Fragment>
                        <SwipeableDrawer
                            className="respHeaderSearch"
                            anchor={'right'}
                            open={openMobileDrawer['right']}
                            disableBackdropTransition={!iOS}
                            disableDiscovery={iOS}
                            disableSwipeToOpen={false}
                            onClose={toggleDrawer('right', false)}
                            onOpen={toggleDrawer('right', true)}
                        >
                            <div className="headRt respNav d-flex justify-content-start align-items-center">
                                <div className="naLogoHead d-flex justify-content-between align-items-center">
                                    <span>
                                        Hello, <br />
                                        {user?.first_name} {user?.last_name}
                                    </span>
                                    <Button
                                        className="headDrawerClose"
                                        onClick={toggleDrawer('right', false)}
                                    >
                                        Close
                                        <span className="material-icons">clear</span>
                                    </Button>
                                </div>
                                <Divider />
                                <ul className="navRespLinks" onClick={toggleDrawer('right', false)}>
                                    <ListItem button>
                                        <NavLink to="/dashboard/profile" activeClassName="active">
                                            My Information
                                        </NavLink>
                                    </ListItem>
                                    <ListItem
                                        button
                                        className={
                                            window.location.search == '/dashboard/mybids'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink to="/dashboard/mybids">My Bids</NavLink>
                                    </ListItem>
                                    <ListItem
                                        button
                                        className={
                                            window.location.search == '/dashboard/mycart'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink to="/dashboard/mycart">My Cart</NavLink>
                                    </ListItem>
                                    {!isBargainsProject && !ThemeConstant?.isBuyBestProject ? (
                                        <>
                                            <ListItem
                                                button
                                                className={
                                                    window.location.search ==
                                                    '/dashboard/scheduledPickup'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink to="/dashboard/scheduledPickup">
                                                    Ready for Pickup
                                                </NavLink>
                                            </ListItem>

                                            <ListItem
                                                button
                                                className={
                                                    window.location.search == 'abandoned'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink to="/dashboard/abandoned">
                                                    Abandoned
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    ) : null}
                                    {global.pluginConfiguration?.extended_pickup?.enable == 1 ? (
                                        <ListItem
                                            button
                                            className={
                                                window.location.search == 'warranty'
                                                    ? 'active'
                                                    : null
                                            }
                                        >
                                            <NavLink to="/dashboard/extendedPickup">
                                                Extended Pickup History
                                            </NavLink>
                                        </ListItem>
                                    ) : (
                                        ''
                                    )}
                                    {global?.pluginConfiguration?.warranty_return_sku?.enable ==
                                    1 ? (
                                        <ListItem
                                            button
                                            className={
                                                window.location.search == 'warranty'
                                                    ? 'active'
                                                    : null
                                            }
                                        >
                                            <NavLink to="/dashboard/warranty">
                                                Extended Pickup
                                            </NavLink>
                                        </ListItem>
                                    ) : (
                                        ''
                                    )}
                                    {global.pluginConfiguration?.reward_points?.enable ? (
                                        <>
                                            <ListItem
                                                button
                                                className={
                                                    window.location.search == 'rewards'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink to="/dashboard/rewards">Rewards</NavLink>
                                            </ListItem>
                                            <ListItem
                                                button
                                                className={
                                                    window.location.search == 'Redeem'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink to="/dashboard/redeem">Rush Perks</NavLink>
                                            </ListItem>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                    {/* <ListItem
                                        button
                                        className={
                                            window.location.search == '?s=0' ? 'active' : null
                                        }
                                    >
                                        <NavLink
                                            to="/dashboard/mybids?s=0"
                                            activeClassName={
                                                window.location.search == '?s=0' ? 'active' : null
                                            }
                                        >
                                            Bids
                                        </NavLink>
                                    </ListItem> */}
                                    <ListItem
                                        button
                                        className={
                                            window.location.pathname == '/449/dashboard/cards'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink to="/dashboard/cards" activeClassName="active">
                                            Saved Cards
                                        </NavLink>
                                    </ListItem>
                                    {isBargainsProject && (
                                        <>
                                            <ListItem
                                                button
                                                className={
                                                    window.location.pathname ==
                                                    '/449/dashboard/transactions'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink
                                                    to="/dashboard/transactions"
                                                    activeClassName="active"
                                                >
                                                    Purchase History
                                                </NavLink>
                                            </ListItem>
                                            <ListItem
                                                button
                                                className={
                                                    window.location.pathname ==
                                                    '/dashboard/preference'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink
                                                    to="/dashboard/preference"
                                                    activeClassName="active"
                                                >
                                                    Preferences
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    )}
                                    <ListItem
                                        button
                                        className={
                                            window.location.pathname == '/449/dashboard/favorites'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink to="/dashboard/favorites" activeClassName="active">
                                            Watchlist
                                        </NavLink>
                                    </ListItem>
                                    <ListItem
                                        button
                                        className={
                                            window.location.pathname == '/449/dashboard/savedSearch'
                                                ? 'active'
                                                : null
                                        }
                                    >
                                        <NavLink
                                            to="/dashboard/savedSearch"
                                            activeClassName="active"
                                        >
                                            Saved Search
                                        </NavLink>
                                    </ListItem>
                                    {!isBargainsProject && (
                                        <>
                                            <ListItem
                                                button
                                                className={
                                                    window.location.pathname ==
                                                    '/449/dashboard/transactions'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink
                                                    to="/dashboard/transactions"
                                                    activeClassName="active"
                                                >
                                                    {ThemeConstant?.isBuyBestProject
                                                        ? 'Book Your Appointment'
                                                        : 'Purchase History'}
                                                </NavLink>
                                            </ListItem>
                                            <ListItem
                                                button
                                                className={
                                                    window.location.pathname ==
                                                    '/dashboard/preference'
                                                        ? 'active'
                                                        : null
                                                }
                                            >
                                                <NavLink
                                                    to="/dashboard/preference"
                                                    activeClassName="active"
                                                >
                                                    Preferences
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    )}

                                    <ListItem button onClick={logoutUser}>
                                        Log Out
                                    </ListItem>
                                </ul>
                            </div>
                        </SwipeableDrawer>
                    </React.Fragment>
                </>
            ) : (
                <div className={classes.grow + ' dashboardMenu orange-header'}>
                    <AppBar position="static" className={classes.dashboardheader}>
                        <Toolbar className={classes.toolbar}>
                            <div className="dbmhead db-head-xs">
                                <img src="/lots-images/dashboard.svg" alt="" /> DASHBOARD
                            </div>
                            <div className={classes.grow} />
                            <ul className={classes.sectionDesktop}>
                                <MenuItem className="dbmlinks">
                                    <NavLink activeClassName="active" to="/dashboard/mybids">
                                        My Bids
                                    </NavLink>
                                </MenuItem>
                                <MenuItem className="dbmlinks">
                                    <NavLink activeClassName="active" to="/dashboard/profile">
                                        Profile
                                    </NavLink>
                                </MenuItem>
                                <MenuItem className="dbmlinks">
                                    <NavLink to="/dashboard/favorites" activeClassName="active">
                                        Favorites
                                    </NavLink>
                                </MenuItem>
                                {global?.pluginConfiguration?.buyers_assurance?.enable == 1 && (
                                    <MenuItem className="dbmlinks">
                                        <NavLink
                                            to="/dashboard/subscription"
                                            activeClassName="active"
                                        >
                                            Subscription
                                        </NavLink>
                                    </MenuItem>
                                )}
                                <MenuItem className="dbmlinks">
                                    <NavLink to="/dashboard/transactions" activeClassName="active">
                                        Invoices
                                    </NavLink>
                                </MenuItem>
                                <MenuItem className="dbmlinks">
                                    <NavLink to="/dashboard/cards" activeClassName="active">
                                        Saved Cards
                                    </NavLink>
                                </MenuItem>
                                <MenuItem className="dbmlinks">
                                    <NavLink to="/dashboard/preference" activeClassName="active">
                                        Preference
                                    </NavLink>
                                </MenuItem>
                                <MenuItem className="dbmlinks">
                                    <NavLink to="/dashboard/barcode" activeClassName="active">
                                        Lotkey
                                    </NavLink>
                                </MenuItem>
                                {global.pluginConfiguration?.ticketing?.enable == 1 && (
                                    <MenuItem className="dbmlinks">
                                        <NavLink to="/dashboard/mytickets" activeClassName="active">
                                            My Tickets
                                        </NavLink>
                                    </MenuItem>
                                )}
                                {global.pluginConfiguration?.referral?.enable == 1 ? (
                                    <MenuItem className="dbmlinks">
                                        <NavLink to="/referral" activeClassName="active">
                                            Referral
                                        </NavLink>
                                    </MenuItem>
                                ) : null}
                                {user &&
                                user.role == 1 &&
                                global.pluginConfiguration?.pos?.enable == 1 ? (
                                    <MenuItem className="dbmlinks">
                                        <NavLink to="/dashboard/pos" activeClassName="active">
                                            POS
                                        </NavLink>
                                    </MenuItem>
                                ) : null}
                            </ul>
                        </Toolbar>
                    </AppBar>
                </div>
            )}
        </>
    )
}

export default withRouter(DashboardHeader)
